<campus-file-icon
  data-cy="search-result-icon"
  class="search-result__file-icon"
  classModifier="product-type-zoekresultaat-algemeen-bestand"
  [icon]="data.eduContent.icon"
></campus-file-icon>

<div class="search-result__title ui-body-2">
  {{ data.eduContent.name }}{{ data.eduContent.eduNetNames.length ? ' - ' + data.eduContent.eduNetNames.join(', ') : '' }}
</div>

<div class="search-result__description ui-caption" [innerHTML]="data.eduContent.description | mathjax"></div>

@if (['paper-exercise'].includes(data.eduContent.type) || data.eduContent.isExercise) {
  <div data-cy="search-result-level" class="search-result__exercise-level ui-body-1">{{ data.eduContent.level?.name }}</div>
}

@if (data.eduContent.publishedEduContentMetadata?.showInFreePractice) {
  <div data-cy="search-result-practice" class="search-result__practice ui-caption">leerling</div>
}

<div class="search-result__actions">
  @for (action of primaryActions; track action.label) {
    <campus-button
      inline
      [matTooltip]="action.tooltip"
      campusClickStopPropagation
      (click)="onActionClick(action)"
      data-cy="search-result-action"
    >
      <campus-icon [svgIcon]="action.icon"></campus-icon>
      <span>{{ action.label }}</span>
    </campus-button>
  }
</div>

@if (secondaryActions.length) {
  <div class="search-result__more-actions">
    <button
      inline-icon-button
      icon="cds-comp:more-vert"
      #moreActions
      clickStopPropagation
      data-cy="btn-show-search-result-actions"
    ></button>
  </div>
  <campus-menu [anchor]="moreActions" positioning="popover" anchorCorner="end-start" menuCorner="start-start">
    @for (action of secondaryActions; track action.label) {
      <campus-menu-item
        class="[ hover:primary-container ]"
        (click)="onActionClick(action)"
        [label]="action.label"
        [leadingIcon]="action.icon"
        data-cy="search-result-action"
      ></campus-menu-item>
    }
  </campus-menu>
}

@if (data.eduContent.publishedEduContentMetadata; as metadata) {
  <div class="search-result__tocs" data-cy="search-result-caption" (click)="metadata.eduContentTOC?.length > 2 && (showMore = !showMore)">
    @if (metadata.eduContentTOC?.length) {
      <div class="search-result__tocs__wrapper">
        @for (tocInfo of metadata.eduContentTOC | tocInfo; track $index; let i = $index) {
          @if (showMore || i < 2) {
            <div class="search-result__toc-info ui-caption" data-cy="search-result-toc-info">{{ tocInfo }}</div>
          }
        }
        @if (metadata.eduContentTOC?.length > 2) {
          <campus-button inline class="search-result__tocs-toggle">
            {{ showMore ? 'toon minder' : 'toon +' + (metadata.eduContentTOC?.length - 2) }}
          </campus-button>
        }
      </div>
    } @else {
      <div class="search-result__book ui-caption">{{ data.eduContent.methodNames.join(', ') }}</div>
    }
  </div>
}
